import styled, { css } from 'styled-components';

export const CardWrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.brand.primaryExtraDark};
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    padding: 16px 32px 0;
    position: relative;
    width: 100%;
    min-height: 80px;
    margin-bottom: 24px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      padding 20px;
      min-height: 196px;
      flex-direction: column;
      margin-bottom: 10px;
      gap: 0;
      align-items: flex-start;
    }
  `}
`;

export const GradientBar = styled.div`
  width: 100%; 
  height: 4px;
  position: absolute;
  bottom: 0;
  background: linear-gradient(90deg, #1D5297 0%, #FFCF00 9.63%, #2E93EE 19.15%, #F67922 28.15%, #2E93EE 39.33%, #FFE885 52.38%, #F67922 63.48%, #2E93EE 73.53%, #1D5297 82.76%, #FFCF00 91.23%, #F67922 100%);
`;

export const SvgWrapper = styled.div`
  ${({ theme }) => css`
    margin-top: 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      display: none;
    }
  `}
`;

export const DivText = styled.div`
    ${({ theme }) => css`
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 16px;
        max-width: 1180px;

        @media (max-width: ${theme.v2.breakpoints.sm}) {
          flex-direction: column;
          width: 100%;
          margin-bottom: 14px;
        }
    `}
`;

export const Title = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.highPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.bold};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0px;

    strong {
      color: ${theme.v2.colors.feedback.attentionPure};
    }
    
    @media (max-width: 720px) {
      font-size: ${theme.v2.font.sizes.xs};
      max-width: 80%;
      order: 1;
      margin-bottom: 4px;
    }

    @media (min-width: ${theme.v2.breakpoints.md} and max-width: ${theme.v2.breakpoints.lg}) {
      font-size: ${theme.v2.font.sizes.xxxs};
    }

    @media (max-width: 1290px) {
      width: 100%;
    }
  `}
`;

export const Description = styled.p`
 ${({ theme }) => css`
    color: ${theme.v2.colors.feedback.canceledLight};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxxs};
    }

    @media (max-width: 720px) {
      font-size: ${theme.v2.font.sizes.xxxs};
      max-width: 80%;
      order: 2;
    }

    @media (min-width: ${theme.v2.breakpoints.md} and max-width: ${theme.v2.breakpoints.lg}) {
      font-size: ${theme.v2.font.sizes.xxxs};
    }
 `}
`;

export const ButtonWrapper = styled.div`
  max-width: 280px;
  padding-right: 30px;
  padding-bottom: 16px;
`;

export const Span = styled.span`
    ${({ theme }) => css`
        background-color: ${theme.v2.colors.brand.primaryUltraLight};
        border-radius: 50px;
        color: ${theme.v2.colors.brand.primaryMedium};
        font-family: ${theme.v2.font.family.primary};
        font-size: ${theme.v2.font.sizes.xxxs};
        font-weight: ${theme.v2.font.weights.medium};
        padding: 4px 8px;
        margin-left: 10px;

        @media (max-width: 960px) {
          order: 0;
          margin-left: 0;
          margin-right: 100%;
          margin-bottom: 5px;
        }

        @media (max-width: 1290px) {
          order: -1;
          margin-left: 0;
          margin-bottom: 5px;
        }
    `}
`;

export const CloseButton = styled.div`
${({ theme }) => css`
  position: absolute;
  right: 16px;
  padding-bottom: 16px;

  @media (max-width: ${theme.v2.breakpoints.sm}) {
    order: 0;
    position: absolute;
    right: 16px;
    top: 16px;
  }
  `}
`;
